// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as SharedHelper$PorterinFeature from "../../../../shared/core/helpers/SharedHelper.mjs";
import * as CustomerReviewCard$PorterinFeature from "../../../../ui/components/CustomerReviewCard.mjs";
import * as CustomerReviewsModuleScss from "../styles/CustomerReviews.module.scss";

var styles = CustomerReviewsModuleScss;

function CustomerReviewsCmp(Props) {
  var testimonials_data = Props.testimonials_data;
  var wave_icon = Props.wave_icon;
  var star_icon = Props.star_icon;
  var testimonials = testimonials_data.testimonials;
  var title = testimonials_data.title;
  var overflowStyle = SharedHelper$PorterinFeature.getOverflowStyle(testimonials.length, styles);
  if (testimonials.length !== 0) {
    return React.createElement("div", {
                className: styles["container-wrapper"]
              }, React.createElement("div", {
                    className: styles["title-container"]
                  }, React.createElement(NextImage$PorterinFeature.make, {
                        src: wave_icon.path,
                        height: 8.0,
                        width: 50.0,
                        quality: 100.0,
                        alt: wave_icon.alt_text
                      }), title.length !== 0 ? React.createElement("h2", {
                          className: styles.title
                        }, title) : null, React.createElement(NextImage$PorterinFeature.make, {
                        src: wave_icon.path,
                        height: 8.0,
                        width: 50.0,
                        quality: 100.0,
                        alt: wave_icon.alt_text
                      })), React.createElement("div", {
                    className: styles["overflow-container"]
                  }, React.createElement("div", {
                        className: "" + styles.container + " " + overflowStyle + ""
                      }, Belt_Array.mapWithIndex(testimonials, (function (index, testimonial) {
                              return React.createElement(CustomerReviewCard$PorterinFeature.make, {
                                          testimonial: testimonial,
                                          star_icon: star_icon,
                                          key: String(index)
                                        });
                            })))));
  } else {
    return null;
  }
}

var make = CustomerReviewsCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
